import React from 'react';
import { ActivityIndicator } from 'react-native';

export const SmallLoader = ({ color = '#000000' }) => (
  <ActivityIndicator size="small" color={color} />
);
